import React, { useState } from "react";
import { Form, Input, Button, Typography, Space } from "antd";
import CustomCard from "../../blocks/Card/Card";

const { Title, Paragraph, Text } = Typography;

const InvestmentPotentialCalculator = () => {
  const [form] = Form.useForm();
  const [roi, setRoi] = useState(null);
  const currentValue = 4000000;

  const calculateROI = () => {
    const values = form.getFieldsValue();
    const investmentAmount = Number(values.investmentAmount);
    const appreciationRate = Number(values.appreciationRate);

    const newValue =
      currentValue * (1 + appreciationRate / 100) + investmentAmount;
    const profit = newValue - currentValue - investmentAmount;
    const calculatedRoi = (profit / investmentAmount) * 100;
    setRoi(calculatedRoi.toFixed(2));
  };

  return (
    <CustomCard
      title={<Title level={4}>Investment Potential Calculator</Title>}
      className="card-height"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ investmentAmount: 50000, appreciationRate: 5 }}
      >
        <Form.Item
          name="investmentAmount"
          label="Investment Amount ($)"
          rules={[
            { required: true, message: "Please input the investment amount!" },
          ]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item
          name="appreciationRate"
          label="Expected Appreciation Rate (%)"
          rules={[
            {
              required: true,
              message: "Please input the expected appreciation rate!",
            },
          ]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" onClick={calculateROI}>
            Calculate ROI
          </Button>
        </Form.Item>

        {roi !== null && (
          <Form.Item>
            <Space>
              <Text strong>Potential ROI:</Text>
              <Text>{roi}%</Text>
            </Space>
          </Form.Item>
        )}
      </Form>

      <Paragraph type="secondary" style={{ marginTop: 16 }}>
        This calculator estimates the potential return on investment (ROI) for
        property improvements. Adjust the investment amount and expected
        appreciation rate to see different scenarios.
      </Paragraph>
    </CustomCard>
  );
};

export default InvestmentPotentialCalculator;
